/* sb-pdp.js — PDP-interactiviteit: variant-picker (option-pills), aantal en galerij.
   Add-to-cart + cart-drawer lopen via Dawn's <product-form> + product-form.js (één bron van waarheid):
   wij houden alleen de hidden [name=id], prijs, voorraad-status en de actieve foto bij. */
(function () {
  function initPdp(root) {
    var dataEl = root.querySelector('[data-sb-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var strings = {
      add: root.getAttribute('data-str-add') || 'In winkelwagen',
      soldOut: root.getAttribute('data-str-soldout') || 'Uitverkocht',
      unavail: root.getAttribute('data-str-unavail') || 'Niet beschikbaar',
      inStock: root.getAttribute('data-str-instock') || 'Op voorraad',
    };

    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-sb-price]');
    var compareEl = root.querySelector('[data-sb-compare]');
    var stockWrap = root.querySelector('[data-sb-stock]');
    var stockText = root.querySelector('[data-sb-stock-text]');
    var submitBtn = root.querySelector('[data-sb-atc]');
    var submitText = submitBtn ? submitBtn.querySelector('span') : null;
    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-sb-option]'));

    // Smaakprofiel dat per roast wisselt (medium/dark).
    var taste = null;
    var tasteEl = root.querySelector('[data-sb-taste]');
    if (tasteEl) { try { taste = JSON.parse(tasteEl.textContent); } catch (e) { taste = null; } }
    var tasteHeading = root.querySelector('[data-sb-taste-heading]');
    var tasteBody = root.querySelector('[data-sb-taste-body]');
    var tasteBars = Array.prototype.slice.call(root.querySelectorAll('[data-sb-bar]'));

    function currentRoast() {
      var r = 'medium';
      optionGroups.forEach(function (g) {
        var a = g.querySelector('.r-opt.is-active');
        if (!a) return;
        var v = a.getAttribute('data-value').toLowerCase();
        if (v.indexOf('dark') > -1) r = 'dark';
        else if (v.indexOf('medium') > -1) r = 'medium';
      });
      return r;
    }
    function applyTaste() {
      if (!taste) return;
      var prof = taste[currentRoast()];
      if (!prof) return;
      if (tasteHeading) tasteHeading.innerHTML = prof.heading;
      if (tasteBody) tasteBody.textContent = prof.body;
      tasteBars.forEach(function (bar, i) {
        var d = prof.bars[i];
        if (!d) return;
        var lbl = bar.querySelector('[data-sb-bar-label]');
        var val = bar.querySelector('[data-sb-bar-value]');
        var fill = bar.querySelector('[data-sb-bar-fill]');
        if (lbl) lbl.textContent = d.l;
        if (val) val.textContent = d.v;
        if (fill) fill.style.setProperty('--w', d.p + '%');
      });
    }

    // "Ideaal voor"-zetmethodes die per maling wisselen (gemalen/bonen). Futureproof: detecteert de
    // maling uit een 'Soort koffie'/'Maling'-optie; valt anders terug op de server-waarde (data-maling).
    var methods = null;
    var methodsEl = root.querySelector('[data-sb-methods]');
    if (methodsEl) { try { methods = JSON.parse(methodsEl.textContent); } catch (e) { methods = null; } }
    var methodItems = Array.prototype.slice.call(root.querySelectorAll('.sb-pbrew__item'));
    var defaultMaling = root.getAttribute('data-maling') || 'gemalen';

    function currentMaling() {
      var m = defaultMaling;
      optionGroups.forEach(function (g) {
        var a = g.querySelector('.r-opt.is-active');
        if (!a) return;
        var v = a.getAttribute('data-value').toLowerCase();
        if (v.indexOf('boon') > -1 || v.indexOf('bonen') > -1) m = 'bonen';
        else if (v.indexOf('gemal') > -1) m = 'gemalen';
      });
      return m;
    }
    function applyMethods() {
      if (!methods) return;
      var set = methods[currentMaling()];
      if (!set) return;
      methodItems.forEach(function (item, i) {
        var d = set[i];
        if (!d) return;
        var ico = item.querySelector('.sb-pbrew__ico');
        var lbl = item.querySelector('.sb-pbrew__label');
        if (ico && d.svg) ico.innerHTML = d.svg;
        if (lbl) lbl.textContent = d.l;
      });
    }

    function currentSelection() {
      return optionGroups.map(function (g) {
        var a = g.querySelector('.r-opt.is-active');
        return a ? a.getAttribute('data-value') : null;
      });
    }
    function findVariant(sel) {
      return variants.find(function (v) {
        return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
      });
    }

    function update() {
      applyTaste();
      applyMethods();
      var v = findVariant(currentSelection());
      if (!v) {
        if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');
        if (submitText) submitText.textContent = strings.unavail;
        if (idInput) idInput.value = '';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) {
        if (v.compare) { compareEl.textContent = v.compare; compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (v.available) {
        if (submitBtn) submitBtn.removeAttribute('aria-disabled');
        if (submitText) submitText.textContent = strings.add;
        if (stockWrap) stockWrap.classList.remove('is-out');
        if (stockText) stockText.textContent = strings.inStock;
      } else {
        if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');
        if (submitText) submitText.textContent = strings.soldOut;
        if (stockWrap) stockWrap.classList.add('is-out');
        if (stockText) stockText.textContent = strings.soldOut;
      }
      if (v.media > 0) activateMedia(v.media);
    }

    optionGroups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var pill = e.target.closest('.r-opt');
        if (!pill || !g.contains(pill)) return;
        g.querySelectorAll('.r-opt').forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-pressed', 'true');
        update();
      });
    });

    // Aantal
    var qtyInput = root.querySelector('[data-sb-qty]');
    var dec = root.querySelector('[data-sb-dec]');
    var inc = root.querySelector('[data-sb-inc]');
    if (qtyInput && dec) dec.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    if (qtyInput && inc) inc.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });

    // Galerij
    var mainImg = root.querySelector('[data-sb-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sb-thumb]'));
    function activateMedia(pos) {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('data-media-pos') === String(pos)) { setMain(thumbs[i]); return; }
      }
    }
    function setMain(thumb) {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (!mainImg) return;
      var full = thumb.getAttribute('data-full');
      if (full) mainImg.src = full;
      var alt = thumb.getAttribute('data-alt');
      if (alt) mainImg.alt = alt;
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { setMain(t); }); });

    // Smaakbalken vloeiend laten groeien zodra de groene sectie in beeld komt (zonder JS staan ze meteen goed).
    var tasteSection = root.querySelector('.sb-ptaste');
    if (tasteSection && 'IntersectionObserver' in window) {
      tasteSection.classList.add('is-collapsed');
      var tasteIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            tasteSection.classList.remove('is-collapsed');
            tasteIO.disconnect();
          }
        });
      }, { threshold: 0.25 });
      tasteIO.observe(tasteSection);
    }
  }

  document.querySelectorAll('[data-sb-pdp]').forEach(initPdp);
})();
